export const ADD = 'addToThread';
export const addToThread = (data) => {
  return {
    type: ADD,
    data,
  };
};
